import React from 'react';
import { isMobile } from 'utilities/browser';
import UploadIcon from 'assets/icons/icon-upload-cloud-gray.svg';
import WarningIcon from 'assets/icons/icon-warning-error-red.svg';
import { formatText, FormattedText } from 'core/i18n';

export const CreateUploadBoxContent = ({ isFileError, shouldBeCaptureType }) => {
    const uploadIcon = isFileError ? (
        <img className="warning-icon" src={WarningIcon} alt="Warning icon" />
    ) : (
        <img className="upload-icon" src={UploadIcon} alt="Upload Icon" />
    );
    const loadAreaTitle = isFileError ? 'uploads-dragDocumentAgain' : 'uploads-dragDocument';
    const loadAreaSubtitle = isMobile() ? 'uploads-uploadDocumentHere' : 'uploads-uploadHere';

    return (
        <div className="load-area-content">
            {uploadIcon}
            <div className="load-area">
                {shouldBeCaptureType ? (
                    <div className="load-area-subtitle">
                        <FormattedText value="uploads-takeAPhoto" />
                    </div>
                ) : (
                    <>
                        {!isMobile() && <div className="load-area-title">{formatText(loadAreaTitle)}</div>}
                        <div className="load-area-subtitle">{formatText(loadAreaSubtitle)}</div>
                    </>
                )}
            </div>
        </div>
    );
};
